import { requestApi } from './Api';

export const getOrders = async (navigate, params) =>
  requestApi({
    navigate,
    url: 'api/clinical_note/orders/get',
    params
  });

export const getOrderResult = async (navigate, params) =>
  requestApi({
    navigate,
    url: 'api/clinical_note/orders/result',
    params
  });

export const shareOrderWithPatient = async (navigate, params) =>
  requestApi({
    navigate,
    url: 'api/clinical_note/orders/share_with_patient',
    params
  });
